export default __webpack_public_path__ + "static/media/olva1.f1328845.jpg";